import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WifiOff, ArrowLeft } from "lucide-react";
import { subscribeOffline } from "@/lib/offline";

export function useOnline() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => subscribeOffline((s) => setOnline(s.online)), []);
  return online;
}

export function OfflineNotice({ feature = "This feature", compact = false }) {
  return (
    <div data-testid="offline-notice" className={`flex flex-col items-center text-center ${compact ? "py-8 px-4" : "pt-16 pb-4 px-6"}`}>
      <div className="h-14 w-14 rounded-2xl bg-[#1E1E1E] border border-[#27272A] flex items-center justify-center mb-4">
        <WifiOff className="h-6 w-6 text-[#F59E0B]" />
      </div>
      <h2 className="font-heading text-lg font-semibold text-[#F3F4F6]">You're offline</h2>
      <p className="mt-1.5 max-w-xs text-sm text-[#9CA3AF]">
        {feature} needs an internet connection. Your notes, reminders and Trash still work offline.
      </p>
    </div>
  );
}

// Wraps an online-only page: shows a friendly offline screen instead of a broken page.
export default function OfflineGate({ feature, children }) {
  const online = useOnline();
  const navigate = useNavigate();
  if (online) return children;
  return (
    <div data-testid="offline-gate" className="min-h-[100dvh] bg-[#0A0A0A] flex flex-col items-center justify-center">
      <OfflineNotice feature={feature} />
      <button
        type="button"
        data-testid="offline-gate-back-btn"
        onClick={() => navigate("/app")}
        className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-medium px-5 py-2.5 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" /> Back to my notes
      </button>
    </div>
  );
}
